import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const getAllCamas = async () => {
  try {
    const response = await axios.get(`${API_URL}/camas`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener camas:', error);
    throw error;
  }
};

export const getCamaById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/camas/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener cama:', error);
    throw error;
  }
};

export const filterCamas = async (query = {}, limit = 10, offset = 1) => {
  try {
    const response = await axios.post(`${API_URL}/camas/filter`, {
      query,
      limit,
      offset
    });
    return response.data;
  } catch (error) {
    console.error('Error al filtrar camas:', error);
    throw error;
  }
};

export const createCama = async (camaData) => {
  try {
    const response = await axios.post(`${API_URL}/camas`, camaData);
    return response.data;
  } catch (error) {
    console.error('Error al crear cama:', error);
    throw error;
  }
};

export const updateCama = async (id, camaData) => {
  try {
    const response = await axios.put(`${API_URL}/camas/${id}`, camaData);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar cama:', error);
    throw error;
  }
};

export const deleteCama = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/camas/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar cama:', error);
    throw error;
  }
};
